// 导入自己需要的组件
import { Upload } from 'element-ui'
const element = {
  install: function (Vue) {
    Vue.use(Upload)
   
  }
}
export default element